import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Sorting } from '../_model/sorting.model';
import { Filter } from '../_model/filter.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class StudentService {
    token = localStorage.getItem('token');

    options = {
        headers: new HttpHeaders({
            // tslint:disable-next-line:object-literal-key-quotes
            'Authorization': `Bearer ${this.token}`
        })
    };

    constructor(private http: HttpClient) { }

    getStudents(rowsNumber: number, pageNo, sorting: Sorting, searchValue: string, filterValues: Filter, request_number: number) {
        let filterValuesForGradesApi = '';
        let filterValuesForClassesApi = '';
        let filterValuesForSoundsApi = '';
        if (filterValues.grades !== undefined) {
            filterValues.grades.map((filterValue: string) => {
                filterValuesForGradesApi = filterValuesForGradesApi.concat('&filter[grade_id][]=' + filterValue)
            })
        }

    
        if (filterValues.classes !== undefined) {
            filterValues.classes.map((filterValue: string) => {
                filterValuesForClassesApi = filterValuesForClassesApi.concat('&filter[class_id][]=' + filterValue)
            })
        }
        
        if (filterValues.sounds !== undefined) {
            filterValues.sounds.map((filterValue: string) => {
                filterValuesForSoundsApi = filterValuesForSoundsApi.concat('&filter[audio_type][]=' + filterValue)
            })
        }
        return this.http.get(environment.url + `schools/${localStorage.getItem('schoolId')}/students?per_page=${rowsNumber}
        ${sorting.name !== null ? '&sort[name]=' + sorting.name : ''}
        ${sorting.class !== null ? '&sort[class_name]=' + sorting.class : ''}
        ${sorting.grade !== null ? '&sort[grade_name]=' + sorting.grade : ''}
        ${filterValuesForGradesApi}
        ${filterValuesForClassesApi}
        ${filterValuesForSoundsApi}
        &role_name=${localStorage.getItem('loginAs')}
        &page=${pageNo}
        ${searchValue === undefined || searchValue === '' ? '' : '&search=' + searchValue} 
    
        &request_number=${request_number}`);
    }

    exportStudentsFile(rowsNumber: number, pageNo, sorting: Sorting, searchValue: string, filterValues: Filter, request_number: number){
        let filterValuesForGradesApi = '';
        let filterValuesForClassesApi = '';
        let filterValuesForSoundsApi = '';
        if (filterValues.grades !== undefined) {
            filterValues.grades.map((filterValue: string) => {
                filterValuesForGradesApi = filterValuesForGradesApi.concat('&filter[grade_id][]=' + filterValue)
            })
        }
        if (filterValues.classes !== undefined) {
            filterValues.classes.map((filterValue: string) => {
                filterValuesForClassesApi = filterValuesForClassesApi.concat('&filter[class_id][]=' + filterValue)
            })
        }
        if (filterValues.sounds !== undefined) {
            filterValues.sounds.map((filterValue: string) => {
                filterValuesForSoundsApi = filterValuesForSoundsApi.concat('&filter[audio_type][]=' + filterValue)
            })
        }
        return this.http.get(environment.url + `schools/${localStorage.getItem('schoolId')}/students/export?${sorting.name !== null ? 'sort[name]=' + sorting.name : ''}
        ${sorting.class !== null ? '&sort[class_name]=' + sorting.class : ''}
        ${sorting.grade !== null ? '&sort[grade_name]=' + sorting.grade : ''}
        ${filterValuesForGradesApi}
        ${filterValuesForClassesApi}
        ${filterValuesForSoundsApi}
        &role_name=${localStorage.getItem('loginAs')}
        ${searchValue === undefined || searchValue === '' ? '' : '&search=' + searchValue} 
        &request_number=${request_number}`);
    }

    deleteStudents(body) {
        body["type"] = "deleted_from_school";
        let options = this.options;
        options['body'] = body;
        return this.http.delete(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/students/delete`, options);
    }

    addStudent(body) {
        return this.http.post(environment.url + `schools/${localStorage.getItem('schoolId')}/students`, body)
    }

    /**
     * v2: identifier collisions come back as a resolvable 409 instead of a 422.
     * Only one conflict is reported per request, so the caller loops until 201.
     */
    addStudentV2(body) {
        return this.http.post(environment.url + `v2/admin/schools/${localStorage.getItem('schoolId')}/students`, body)
    }

    updateStudent(studentID, body) {
        return this.http.post(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/students/${studentID}`, body)
    }

    updateStudentInChangeSchoolRequest(studentID, body) {
        return this.http.put(environment.url + `v2/user/students/${studentID}/edit-change-school-request`, body)
    }


    getStudentById(id) {
        return this.http.get(environment.url + `admin/students/${id}`)
    }

    /**
     * Type-ahead for the Add Parent student picker. Searches name and national
     * ID together, over this school's verified and unverified students alike.
     *
     * A bare array, never paginated, capped at 5 by the server and ordered by
     * name — so a full five means "keep typing", not "that is all there is".
     * There is no minimum term length; the cap is what keeps a one-character
     * search cheap.
     */
    searchStudents(term: string) {
        return this.http.get(environment.url + `v2/admin/schools/${localStorage.getItem('schoolId')}/students/search?search=${encodeURIComponent(term)}`)
    }

    private _studentData = new BehaviorSubject<Object>(null);
    studentData = this._studentData.asObservable();

    setStudentData(student, flag) {
        this._studentData.next({ 'student': student, 'flag': flag });
    }

    getStudentData() {
        return this._studentData;
    }

    uploadStudentAudio(studentId , body){
        return this.http.post(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/students/${studentId}/audio`, body,{
            reportProgress:true,
            observe:'events'
        })
    }

    deleteStudentAudio(studentId,voiceId){
        return this.http.delete(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/students/${studentId}/audio/${voiceId}`);

    }
}
